
import * as angular from "angular";

interface ICompareToDirectiveScope extends angular.IScope {
    otherModelValue: any;
}

export class CompareToDirective implements angular.IDirective {

    restrict = "A";
    require = "ngModel";
    scope = {
        otherModelValue: "=compareTo"
    };

    link: (scope: ICompareToDirectiveScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ngModel) => void;

    constructor() {

        CompareToDirective.prototype.link = ($scope: ICompareToDirectiveScope, $element: angular.IAugmentedJQuery, $attrs: ng.IAttributes, ngModel: angular.INgModelController) => {

            if (!ngModel) {
                return;
            }

            ngModel.$validators["compareTo"] = (modelValue) => {
                return modelValue === $scope.otherModelValue;
            };

            $scope.$watch("otherModelValue", () => {
                ngModel.$validate();
            });

            $attrs.$observe('ngModel', () => {
                ngModel.$validate();
            });
        }
    }

    static factory(): angular.IDirectiveFactory {
        const directive = () => new CompareToDirective();

        directive.$inject = [];

        return directive;
    }
}
